import { render, staticRenderFns } from "./WildtechView.vue?vue&type=template&id=8912594c"
import script from "./WildtechView.vue?vue&type=script&lang=js"
export * from "./WildtechView.vue?vue&type=script&lang=js"
import style0 from "./WildtechView.vue?vue&type=style&index=0&id=8912594c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports